export default __webpack_public_path__ + "images/0738051cea40b04735c39647423b1243.png";